import { useMediaQuery, useTheme } from "@mui/material";

export const useSmallScreenSize = () => {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.down("sm"));
};
